import React, { useEffect, useState } from 'react';
import api from '../api/client';
import logo from '../logo.png';
import FitToScreen from '../components/FitToScreen';

const POLL_INTERVAL = 15000; // ms — client-driven refresh, no reload needed by signage software

export default function InfoShow() {
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      api.get('/api/info').then((r) => { if (!cancelled) setEntries(r.data || []); }).catch(() => {});
    };
    load();
    const interval = setInterval(load, POLL_INTERVAL);
    return () => { cancelled = true; clearInterval(interval); };
  }, []);

  return (
    <div className="fixed inset-0 bg-ocean-950 flex flex-col overflow-hidden select-none">
      {/* Titel */}
      <div className="flex-shrink-0 flex justify-center" style={{ padding: 'clamp(20px, 4vh, 48px) clamp(16px, 4vw, 60px) clamp(8px, 2vh, 24px)' }}>
        <h1 className="text-sand-300 font-black uppercase tracking-widest drop-shadow-lg text-center"
          style={{ fontSize: 'clamp(1.6rem, 5vh, 3.6rem)' }}>
          BeachLAN Infos
        </h1>
      </div>

      {/* Einträge */}
      <div className="flex-1 min-h-0" style={{ padding: '0 clamp(16px, 4vw, 60px) clamp(90px, 14vh, 160px)' }}>
        {entries.length === 0 ? (
          <div className="w-full h-full flex items-center justify-center">
            <p className="text-white/30 text-xl tracking-widest uppercase">Keine Infos hinterlegt</p>
          </div>
        ) : (
          <FitToScreen maxScale={2}>
            <div
              className="grid items-start"
              style={{
                gap: '22px',
                width: '92vw',
                minWidth: 480,
                gridTemplateColumns: 'repeat(auto-fit, minmax(440px, 1fr))',
              }}
            >
              {entries.map((entry) => (
                <div
                  key={entry.id}
                  className="rounded-2xl border border-white/10 bg-white/[0.04] px-8 py-6 flex flex-col"
                >
                  <p className="text-sand-300 font-black uppercase tracking-wide drop-shadow" style={{ fontSize: '1.75rem' }}>
                    {entry.title}
                  </p>
                  <p className="text-white font-medium whitespace-pre-line mt-3" style={{ fontSize: '1.5rem', lineHeight: 1.5 }}>
                    {entry.content}
                  </p>
                </div>
              ))}
            </div>
          </FitToScreen>
        )}
      </div>

      {/* Logo unten links */}
      <div className="absolute left-8 bottom-6 flex items-center z-20">
        <img src={logo} alt="BeachLAN" className="w-auto object-contain drop-shadow-lg opacity-90"
          style={{ height: 'clamp(48px, 8vh, 110px)' }} />
      </div>
    </div>
  );
}
